import * as Actions from '../../actions/estimator/type';

export const EstimateReducer = (state = {}, action) => {
  switch (action.type) {
    // ==============creating jobs from estimator=========
    case Actions.CREATE_ESTIMATOR_JOB_REQUEST:
      return {
        ...state,
        jobLoader: true,
      };
    case Actions.CREATE_ESTIMATOR_JOB_SUCCESS:
      return {
        ...state,
        jobLoader: false,
        createdJob: action.payload?.data || {},
      };
    case Actions.CREATE_ESTIMATOR_JOB_FAIL:
      return {
        ...state,
        jobLoader: false,
        error: action.payload,
      };
    // ==============creating inventory item=========
    case Actions.SAVE_ITEM_TO_INVENTORY_REQUEST:
      return {
        ...state,
        inventoryItemLoader: true,
      };
    case Actions.SAVE_ITEM_TO_INVENTORY_SUCCESS:
      return {
        ...state,
        inventoryItemLoader: false,
        createdInventoryItem: action.payload?.data || {},
      };
    case Actions.SAVE_ITEM_TO_INVENTORY_FAIL:
      return {
        ...state,
        inventoryItemLoader: false,
        error: action.payload,
      };

    // ==============creating estimator=========
    case Actions.CREATE_ESTIMATOR_REQUEST:
      return {
        ...state,
        estimatorLoader: true,
      };
    case Actions.CREATE_ESTIMATOR_SUCCESS:
      return {
        ...state,
        estimatorLoader: false,
        createdEstimator: action.payload || {},
      };
    case Actions.CREATE_ESTIMATOR_FAIL:
      return {
        ...state,
        estimatorLoader: false,
        createEstimateError: action.payload,
      };
    case Actions.CLEAR_CREATE_ESTIMATOR_STATES:
      return {
        ...state,
        estimatorLoader: false,
        createdEstimator: '',
        createEstimateError: '',
      };
    // ==============get estimate list=========
    case Actions.GET_ESTIMATES_REQUEST:
      return {
        ...state,
        getEstimatorsLoader: true,
      };
    case Actions.GET_ESTIMATES_SUCCESS:
      return {
        ...state,
        getEstimatorsLoader: false,
        estimates: action.payload?.data || {},
        count: action?.payload?.count || 0,
        totalCount: action?.payload?.totalCount,
      };
    case Actions.GET_ESTIMATES_FAIL:
      return {
        ...state,
        getEstimatorsLoader: false,
        error: action.payload,
      };

    // ==============get estimate by id=========
    case Actions.GET_ESTIMATE_REQUEST:
      return {
        ...state,
        getEstimatorLoader: true,
      };
    case Actions.GET_ESTIMATE_SUCCESS:
      return {
        ...state,
        getEstimatorLoader: false,
        estimate: action.payload?.data || {},
      };
    case Actions.GET_ESTIMATE_FAIL:
      return {
        ...state,
        getEstimatorLoader: false,
        error: action.payload,
      };

    // ==============delete estimate=========
    case Actions.DELETE_ESTIMATE_REQUEST:
      return {
        ...state,
        deleteEstimatorLoader: true,
      };
    case Actions.DELETE_ESTIMATE_SUCCESS:
      return {
        ...state,
        deleteEstimatorLoader: false,
        deletedEstimate: action.payload?.data || {},
      };
    case Actions.DELETE_ESTIMATE_FAIL:
      return {
        ...state,
        deleteEstimatorLoader: false,
        deleteEstimateError: action.payload,
      };

    // ==========updating list after deleting========
    case Actions.UPDATE_LIST_ON_DELETE_ESTIMATE:
      const estimateId = action?.payload?.id;
      const filteredList = state?.estimates?.filter(
        (esti) => esti?.id !== estimateId,
      );
      return {
        ...state,
        estimates: filteredList,
      };

    // ============clear deleted estimate state=========
    case Actions.CLEAR_DELETED_ESTIMATE_STATE:
      return {
        ...state,
        deleteEstimatorLoader: false,
        deletedEstimate: '',
        deleteEstimateError: '',
      };
    // ==============convert to ro =========
    case Actions.CONVERT_TO_RO_REQUEST:
      return {
        ...state,
        convertRoLoader: true,
      };
    case Actions.CONVERT_TO_RO_SUCCESS:
      return {
        ...state,
        convertRoLoader: false,
        roData: action.payload?.data || '',
      };
    case Actions.CONVERT_TO_RO_FAIL:
      return {
        ...state,
        convertRoLoader: false,
        convertRoError: action.payload,
      };

    case Actions.CLEAR_ESTIMATOR_STATE:
      return {
        ...state,
        createdJob: '',
        createdInventoryItem: '',
        estimate: '',
        convertRoLoader: false,
        roData: '',
        convertRoError: '',
      };
    // ============== authorize estimator =========
    case Actions.AUTHORIZE_ESTIMATOR_REQUEST:
      return {
        ...state,
        authorizeEstimatorLoading: true,
      };
    case Actions.AUTHORIZE_ESTIMATOR_SUCCESS:
      return {
        ...state,
        authorizeEstimatorLoading: false,
        authorizeEstimator: action.payload?.data || '',
      };
    case Actions.AUTHORIZE_ESTIMATOR_FAIL:
      return {
        ...state,
        authorizeEstimatorLoading: false,
        authorizeEstimatorError: action.payload,
      };
    case Actions.CLEAR_AUTHORIZE_ESTIMATOR_STATESL:
      return {
        ...state,
        authorizeEstimatorLoading: false,
        authorizeEstimator: '',
        authorizeEstimatorError: '',
      };
    case Actions.NAV_BAR_STATE:
      return {
        ...state,
        navBarStatus: action.payload,
      };

    case Actions.UPDATE_ESTIMATOR_JOB_LIST:
      let jobs = [];
      if (action?.payload?.nexPart) {
        // if items comes from next part to update the jobs items
        // jobs will pass from component which contain updated items
        jobs = [...(action?.payload?.jobs || [])];
      } else if (action?.payload?.partTech) {
        console.log(action.payload, 'action?.payload');
        // if items comes from partTech to update the jobs items
        // jobs will pass from component which contain updated items
        jobs = [...(action?.payload?.jobs || [])];
      } else {
        jobs = [...(state?.jobs?.jobs || [])];
      }
      if (action?.payload?.isDelete) {
        const filteredJobs = jobs?.filter(
          (job) => job?.id !== action?.payload?.jobId,
        );
        jobs = filteredJobs;
      } else if (action?.isCanned) {
        jobs = [...jobs, ...action.payload?.data?.job];
      } else if (action?.payload?.nexPart) {
        jobs = [...action?.payload?.jobs];
      } else if (action?.payload?.partTech) {
        jobs = [...action?.payload?.jobs];
      } else {
        jobs = [...jobs, action.payload?.data?.job];
      }
      console.log('UPDATE_ESTIMATE_JOB_LISTReducer in estimator >>>>>>', state);
      console.log(
        'UPDATE_ESTIMATE_JOB_LISTReducer in estimator >>>>>>',
        action.payload,
      );
      return {
        ...state,
        jobs: {
          ...state?.jobs,
          jobs: [...jobs],
        },
      };
    default:
      return state;
  }
};
